// MWA-391 — the client emails a workflow stage can send when a client enters it.
//
// Which one (if any) is a setting on each stage in Stage Gates, stored as
// `entryEmail` on the stage definition. The values are the ids advance-workflow-
// stage knows how to send; manage-workflow-stages validates against the same
// list. A test keeps this file and the backend list in step.
export interface StageEntryEmailOption {
  value: string
  label: string
  // Completes "Moving this client to <stage> will …" in the Advance Stage dialog.
  notice: string
}

export const STAGE_ENTRY_EMAIL_OPTIONS: readonly StageEntryEmailOption[] = [
  {
    value: 'initial_consultation',
    label: 'Initial Consultation invite',
    notice: 'send an email to the client to schedule their Initial Consultation.',
  },
  {
    value: 'cliftonstrengths_booking',
    label: 'CliftonStrengths review booking',
    notice: 'send them an automated email with a one-time Calendly link to book their CliftonStrengths review with Dee.',
  },
  {
    value: 'linkedin_workshop_invite',
    label: 'LinkedIn Workshop invite',
    notice: 'send an email to the client to schedule their LinkedIn Workshop.',
  },
]

export function stageEntryEmailOption(value: string | null | undefined): StageEntryEmailOption | undefined {
  return STAGE_ENTRY_EMAIL_OPTIONS.find((option) => option.value === value)
}
